<template>
  <div class="stats-placeholder pa-6">
    <v-row justify="center" align="center" class="fill-height" style="min-height: 300px">
      <v-col cols="12" class="text-center">
        <v-icon size="64" color="grey lighten-1">mdi-chart-bar</v-icon>
        <div class="text-h6 grey--text mt-4">{{ $t("statistics_meals_placeholder") }}</div>
        <div class="text-body-2 grey--text text--lighten-1 mt-2">
          {{ $t("statistics_coming_soon") }}
        </div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: "RestaurantMealsStats",
};
</script>
